import React from "react";
import "./App.css";
import Oracle from "./components/Oracle";

const App = () => {
  return <Oracle />;
};

export default App;
